import styled from 'styled-components';
import { zFloatingPanels } from '~/styled';
import { headerHeight } from '~/styled/GlobalStyles';

interface Props {
  $position: 'left' | 'right';
  $visible: boolean;
}

const getPosition = ({ $position, $visible }: Props) => {
  if ($visible) {
    return '0';
  }
  if ($position === 'left') {
    return '-100vw';
  }
  if ($position === 'right') {
    return '100vw';
  }
};

export const NavigationDrawer = styled.aside<Props>`
  position: fixed;
  left: ${({ $position, $visible }) => getPosition({ $position, $visible })};
  height: calc(100dvh - ${() => headerHeight} - var(--top-banner-offset, 0px));
  top: calc(${() => headerHeight} + var(--top-banner-offset, 0px));
  background-color: ${({ theme }) => theme.colors.background};
  width: 100vw;
  overflow-y: scroll;
  transition: left 200ms ease-out;
  z-index: ${() => zFloatingPanels};
`;

export const TransparentButton = styled.button`
  border-style: none;
  background-color: ${({ theme }) => theme.colors.background};
`;
